module.exports = __webpack_public_path__ + "static/img/03-5.8763de9a.png";